import { render, staticRenderFns } from "./ngo-map.vue?vue&type=template&id=89d34916&"
import script from "./ngo-map.vue?vue&type=script&lang=js&"
export * from "./ngo-map.vue?vue&type=script&lang=js&"
import style0 from "./ngo-map.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports